var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.076 3.41352L19.6778 7.11313C19.8295 7.26899 19.8295 7.52329 19.6778 7.67915L10.9569 16.637L7.25139 17.0594C6.75625 17.1168 6.33698 16.6862 6.39288 16.1776L6.80417 12.3713L15.525 3.41352C15.6767 3.25766 15.9243 3.25766 16.076 3.41352ZM22.5448 2.47427L20.5962 0.472705C19.9892 -0.150732 19.003 -0.150732 18.392 0.472705L16.9785 1.92466C16.8267 2.08052 16.8267 2.33481 16.9785 2.49067L20.5802 6.19028C20.7319 6.34614 20.9795 6.34614 21.1313 6.19028L22.5448 4.73833C23.1517 4.11079 23.1517 3.0977 22.5448 2.47427ZM15.3333 14.2006V18.376H2.55556V5.25102H11.7316C11.8594 5.25102 11.9792 5.1977 12.071 5.10747L13.6682 3.46684C13.9717 3.15513 13.7561 2.62602 13.3288 2.62602H1.91667C0.858507 2.62602 0 3.50786 0 4.59477V19.0323C0 20.1192 0.858507 21.001 1.91667 21.001H15.9722C17.0304 21.001 17.8889 20.1192 17.8889 19.0323V12.56C17.8889 12.1211 17.3738 11.9038 17.0703 12.2114L15.4731 13.852C15.3852 13.9463 15.3333 14.0694 15.3333 14.2006Z",
    fill: "#5FB6D9 "
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4b7c5e3395222e2bd8940194cbbcbfd2.svg";
export { ForwardRef as ReactComponent };